
// import component

import Complete_apps from "../components/complete-apps/Complete_apps";

const Project_page = () => {


  return (
    <>
      <Complete_apps />
      
    </>
  );
};
export default Project_page;
